<template>
  <v-container fluid class="pa-0" style="background-color: white;">
    <TaskManager ref="taskstatuses">
    </TaskManager>

    <v-divider></v-divider>

    <v-row no-gutters class="pa-3 pb-0">
      <v-col cols="0">
        <h3>Task log feed</h3>
      </v-col>
      <v-col cols="auto">
        <RefreshBtn :method="() => { getLogs() }" :externalLoading="loading"
          :tip="$t('servicesystem.common_objects.job.refresh_list')" :size="'small'" :autoTimer="10000">
        </RefreshBtn>
      </v-col>
    </v-row>

    <v-progress-linear v-if="initialLoading" :indeterminate="!initialLoading" absolute>
    </v-progress-linear>
    <v-data-table v-else-if="logglist && logglist.length" :headers="headers" :items="logglist" :items-per-page="-1"
      hideDefaultFooter :fixed-header="true" height="calc(100vh - 430px)" :loading="loading">
      <template v-slot:item.Status="{ item }">
        <v-chip small :color="statusColor(item)" dark style="border-radius: 4px;">
          {{ item.Status }}
        </v-chip>
      </template>
      <template v-slot:item.Text="{ item }">
        <v-card width="400" color="transparent" flat>
          {{ item.Text }}
        </v-card>
      </template>
    </v-data-table>
    <div v-else>
      error or no items
    </div>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import RefreshBtn from "@/components/Buttons/RefreshDataBtn.vue";
import TaskManager from "@/components/Task/TaskManager.vue";

export default {
  name: "TaskLogList",
  components: {
    RefreshBtn,
    TaskManager
  },
  mixins: [clientAPI],

  data() {
    return {
      initialLoading: false,
      loading: false,
      logglist: null,
      headers: [
        { text: '#', value: 'Id' },
        { text: 'Status', value: 'Status' },
        { text: 'Name', value: 'TaskName' },
        { text: 'TimeStamp', value: 'TimeStamp' },
        { text: 'Text', value: 'Text', },
      ],
    };
  },

  mounted() {
    this.initialLoading = true;
    this.getLogs();
    this.initialLoading = false;
  },

  methods: {
    getLogs() {
      this.loading = true;
      clientAPI.methods.getTaskLogs()
        .then((response) => {
          this.logglist = response;

        })
        .catch((exception) => console.log(exception))
        .finally(() => (this.loading = false));
    },

    statusColor(item) {
      if (item.Status == 'Started') {
        return 'tertiary';
      }
      else if (item.Status == 'Complete') {
        return 'success';
      }
      else if (item.Status == 'Failed') {
        return 'error';
      }
      else if (item.Status == 'Cancelled') {
        return 'warning';
      }
      else if (item.Status == 'Queued') {
        return 'primary';
      }
      else {
        return '';
      }
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>